<!-- eslint-disable max-len -->
<template>
  <aha-modal
    :title="$i18nPresenter.t('Presentation too large')"
    @hide="$emit('hide')"
  >
    <p>
      {{ $i18nPresenter.t('Sorry, this presentation has reached the maximum slide limit. Please consider removing some slides or creating a new presentation.') }}
    </p>

    <template #action>
      <aha-antd-button
        v-aha-emit-action
        name="presentation-limit-button"
        variant="danger"
        @click="$emit('hide')"
      >
        {{ $i18nPresenter.t('OK') }}
      </aha-antd-button>
    </template>
  </aha-modal>
</template>

<script>
export default {
}
</script>
